
export class Cause {

  constructor(
    public code?: number,
    public description?: string,
    public imputable?: string,
    public isImputable?: Boolean,
  ) { }

  clone() {
    return new Cause(
      this.code,
      this.description,
      this.imputable,
      this.isImputable,
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/cause.ts